import React from "react"
import PropTypes from "prop-types"
import { Card } from "semantic-ui-react"
import { Doughnut } from "react-chartjs-2"

const colors = ["#36A2EB", "#D12475", "#22C72D", "#c9d437", "#732280"]

const days = []

for (let i = 1; i < 32; i++) {
  days.push(i)
}

const options = {
  legend: {
    display: false,
  },
  tooltips: {
    enabled: false,
  },
  cutoutPercentage: 50,
  rotation: -0.5 * Math.PI,
  circumference: 2 * Math.PI,
  animation: {
    animateRotate: true,
    animateScale: false,
  },
}

export const ShardedAnalyticsDonut = (props) => {
  const { isLoading, titles, data } = props
  const chartData = {
    datasets: [{ data: [], backgroundColor: colors }],
    labels: titles,
  }

  data.map((data, i) => {
    if (data.length > 0) {
      let result = data.reduce((sum, current) => {
        return sum + current.value
      }, 0)
      chartData.datasets[0].data.push(result)
    }
  })
  return (
    <Card centered fluid>
      <Doughnut data={chartData} options={options} redraw={true} />
    </Card>
  )
}

ShardedAnalyticsDonut.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      at: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    }),
  ).isRequired,
  isLoading: PropTypes.bool,
}
